import { get } from '../utils/api';

// A read that never settles would keep the hooks' last good answer forever. A failed read counts
// toward their five-minute limit.
export const PROVIDER_READ_TIMEOUT_MS = 20000;

// The abort signal stops the fetch, but requestAPI can also wait on a token renewal it does not
// reach, and it resolves an unreadable body as null. So the whole read is bounded here, and an
// empty answer is a failure.
const boundedRead = (read: (signal: AbortSignal) => Promise<mixed>) =>
  new Promise((resolve, reject) => {
    const timer = setTimeout(
      () => reject(new Error('The lease signing provider read timed out')),
      PROVIDER_READ_TIMEOUT_MS,
    );
    read(AbortSignal.timeout(PROVIDER_READ_TIMEOUT_MS)).then(
      (body) => {
        clearTimeout(timer);
        if (body === null || body === undefined) {
          reject(new Error('The lease signing provider read returned no body'));
        } else {
          resolve(body);
        }
      },
      (error) => {
        clearTimeout(timer);
        reject(error);
      },
    );
  });

export const getLeaseSigningProvider = (
  organizationId: string,
  propertyId: string,
  leaseId?: ?string,
) => {
  const leasePath = leaseId ? `/lease/${leaseId}` : '';
  return boundedRead((signal) =>
    get(
      `/api/v2/${organizationId}/${propertyId}${leasePath}/lease-signing-provider`,
      { signal },
    ),
  );
};

// The full error body carries the status, so a 403 can be told apart from an outage.
export const getBlueMoonActiveProperties = (organizationId: string) =>
  boundedRead((signal) =>
    get(
      `/api/v2/${organizationId}/lease-signing-provider/blue-moon-properties`,
      { fullError: true, signal },
    ),
  );
